// Small inline loading indicator — a gently pulsing ॐ, matching the app's
// boot loader (replaces bare "…" text on content pages).
export default function OmSpinner({ label = "", className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-20 ${className}`} data-testid="om-spinner">
      <span className="font-deva text-4xl text-saffron om-pulse" aria-hidden="true">ॐ</span>
      {label && <span className="text-sm text-ink-3">{label}</span>}
      <span className="sr-only">Loading…</span>
    </div>
  );
}
